import React, { Component } from 'react';
import { withNamespaces } from 'react-i18next';

import { Box, Text } from 'components/Wrapped';
import { nestedTranslate } from 'utils/strings';

class Copyright extends Component {
  render() {
    const { t: translate, exchangeName } = this.props;
    const t = nestedTranslate(translate, 'footer.copyright');
    const year = new Date().getFullYear();

    return (
      <Box align="center" pad="none">
        <Text color="#B4B6B7" size="12px" weight={600} style={{ lineHeight: '16px' }}>
          {t('company', { year, exchangeName })}
        </Text>
      </Box>
    );
  }
}

export default withNamespaces()(Copyright);
